export const DRAFT_JS_EMPTY_DESCRIPTION = `<p></p>`; // draftJS considers this as empty state, not an empty string
